import { ReportPermissions } from '@sr/dto';
import { useStateSelector } from 'shared/store';
import { reportsLinkManager } from 'utils/link-manager';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useTitleHook } from 'hooks/page-title.hook';

import { Link, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { CashBalance } from 'features/reports/cash-balance';
import { Sales } from 'features/reports/sales';
import { CashFlow } from 'features/reports/cash-flow';
import { Calls } from 'features/reports/calls';
import { TopManager } from 'features/reports/top-manager';

const tabInfos = [
  {
    path: reportsLinkManager.tabs.cashBalance,
    label: 'Остатки по счетам',
    icon: <AccountBalanceIcon />,
    component: <CashBalance />
  },
  {
    path: reportsLinkManager.tabs.sales,
    label: 'Продажи',
    icon: <MonetizationOnIcon />,
    component: <Sales />
  },
  {
    path: reportsLinkManager.tabs.cashFlow,
    label: 'Денежный поток',
    icon: <CurrencyExchangeIcon />,
    component: <CashFlow />
  },
  {
    path: reportsLinkManager.tabs.calls,
    label: 'Телефонные звонки',
    icon: <LocalPhoneIcon />,
    component: <Calls />
  },
  {
    path: reportsLinkManager.tabs.topManager,
    label: 'ТОП менеджер',
    icon: <PeopleAltIcon />,
    component: <TopManager />
  }
];

const ReportsPage = () => {
  useTitleHook('Отчеты');
  return (
    <>
      <ReportsTabs />

      <Routes>
        <Route element={<Outlet />}>
          {tabInfos.map((tab) => (
            <Route path={tab.path} element={tab.component} key={tab.path} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

const ReportsTabs = () => {
  const location = useLocation();
  const canViewTopManager = useStateSelector((state) => state.auth.user?.permissions.includes(ReportPermissions.VIEW_TOP_MANAGER));
  const visibleTabs = tabInfos.filter((tab) => tab.path !== reportsLinkManager.tabs.topManager || canViewTopManager);

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs value={visibleTabs.some((tab) => location.pathname === `/${reportsLinkManager.baseUrl}/${tab.path}`) ? location.pathname : false}>
        {visibleTabs.map((tab) => (
          <Tab key={tab.path} label={tab.label} value={`/${reportsLinkManager.baseUrl}/${tab.path}`} iconPosition="start" icon={tab.icon} to={tab.path} component={Link} />
        ))}
      </Tabs>
    </Box>
  );
};
export default ReportsPage;
